"use strict";

var _slicedToArray = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToggleSizes = void 0;

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var react_1 = require("react");

var styles = tslib_1.__importStar(require("./Toggle.style"));

exports.ToggleSizes = ['sm', 'md'];

function Toggle(_ref) {
  var className = _ref.className,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'md' : _ref$size,
      _ref$checked = _ref.checked,
      checked = _ref$checked === void 0 ? false : _ref$checked,
      onChange = _ref.onChange;

  var _react_1$useState = react_1.useState(checked),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      isChecked = _react_1$useState2[0],
      setChecked = _react_1$useState2[1];

  var handleChange = function handleChange(_ref2) {
    var target = _ref2.target;
    setChecked(target.checked);
    onChange && onChange(target.checked);
  };

  return jsx_runtime_1.jsxs("div", Object.assign({
    className: className,
    css: [styles.container, styles.sizeStyles[size], isChecked && styles.active(size)]
  }, {
    children: [jsx_runtime_1.jsx("span", {
      css: styles.icon
    }, void 0), jsx_runtime_1.jsx("input", {
      type: "checkbox",
      id: "toggle",
      css: styles.input,
      checked: isChecked,
      onChange: handleChange
    }, void 0)]
  }), void 0);
}

exports.default = react_1.memo(Toggle);